export default "__VITE_ASSET__9sjhiTiv__"